var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud',{ref:"crud",attrs:{"prefix":_vm.prefix,"path":_vm.path,"paths":_vm.paths,"page-title":_vm.pageTitle,"fields-info":_vm.fieldsInfo,"details-title":_vm.$t('detailsTitle'),"custom-buttons":_vm.buttons,"item-elements":_vm.itemElements}})}
var staticRenderFns = []

export { render, staticRenderFns }